import React from 'react'
import c from 'classnames'
import Img from "components/Img"

import SliderControlsImg from './images/slider-controls.svg'

import './style'
import './media'

export const NextArrow = props => (
    <div className={c("slider-control slider-control_right", props.className)} style={props.style} onClick={props.onClick}>
        <div className="icon">
            <Img src={SliderControlsImg} div/>
        </div>
    </div>
)

export const PrevArrow = props => (
    <div className={c("slider-control slider-control_left", props.className)} style={props.style} onClick={props.onClick}>
        <div className="icon">
            <Img src={SliderControlsImg} div/>
        </div>
    </div>
)

export const DarkNextArrow = props => (
    <div className={c("slider-control slider-control_right dark-slider-control", props.className)} style={props.style} onClick={props.onClick}>
        <div className="icon">
            <Img src={SliderControlsImg} div/>
        </div>
    </div>
)

export const DarkPrevArrow = props => (
    <div className={c("slider-control slider-control_left dark-slider-control", props.className)} style={props.style} onClick={props.onClick}>
        <div className="icon">
            <Img src={SliderControlsImg} div/>
        </div>
    </div>
)